import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";

const Navbar = () => {
  const { isAuthenticated } = useContext(AuthContext);
  if (!isAuthenticated) return;
  return (
    <nav className="bg-gray-800 p-4 text-white">
      <div className="container mx-auto">
        <ul className="flex space-x-4">
          <li>
            <Link to="/properties">Properties</Link>
          </li>
          <li>
            <Link to="/categories">Categories</Link>
          </li>
          <li>
            <Link to="/orders">Orders</Link>
          </li>
          <li>
            <Link to="/contact-requests">Contact Requests</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
